import "./style.scss"
import React from "react"
import _ from "lodash"
import pointIcon from "../../../images/Icon-point.svg"
import benefits from "../../../images/benefits.png"
import vector from "../../../images/Vector.png"
import {
	Card,
	CardHeader,
	makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'

const useStyles = makeStyles((theme)=>({
  card: {
    padding: '40px 15px 10px 15px',
    minHeight: '243px',
    backgroundColor: '#FBFAFA',
    borderRadius: '10px',
    boxShadow: '0px 4px 6px 2px rgb(11 11 11 / 25%)',
    maxWidth: '790px',
  },
  cardSection: {
    display: 'contents',
  },
  icons: {
    position: 'absolute',
    marginLeft: '9.5%',
    marginTop: '-6%',
    [theme.breakpoints.up(1200)]: {
      marginTop: '-6%',
    },
    [theme.breakpoints.between(1023, 1200)]: {
      marginTop: '-7%',
    },
    [theme.breakpoints.between(970, 1023)]: {
      marginTop: '-9%',
      marginLeft: '35%',
    },
    [theme.breakpoints.between(750, 970)]: {
      marginTop: '-10%',
      marginLeft: '37%',
    },
    [theme.breakpoints.between(700, 750)]: {
      marginTop: '-13%',
      marginLeft: '37%',
    },
    [theme.breakpoints.between(600, 700)]: {
      marginTop: '-13%',
      marginLeft: '35%',
    },
    [theme.breakpoints.between(540, 600)]: {
      marginTop: '-16%',
      marginLeft: '33%',
    },
    [theme.breakpoints.between(460, 540)]: {
      marginTop: '-18%',
      marginLeft: '31%',
    },
    [theme.breakpoints.between(400, 460)]: {
      marginTop: '-21%',
      marginLeft: '28%',
    },
    [theme.breakpoints.between(360, 400)]: {
      marginTop: '-24%',
      marginLeft: '25%',
    },
    [theme.breakpoints.between(335, 360)]: {
      marginTop: '-29%',
      marginLeft: '23%',
    },
    [theme.breakpoints.between(300, 335)]: {
      marginTop: '-30%',
      marginLeft: '21%',
    },
    [theme.breakpoints.down(300)]: {
      marginTop: '-35%',
      marginLeft: '15%',
    },
  },
}))

const Benefits = ({
  points,
  points_1,
  points_1_mob,
  pointsSubText,
  pointsTitle,
  pointsSubtitle,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(1023))
  const point1 = isMobile ? points_1_mob : points_1

  return (
    <div className="point_container" id='benefits'>
      {pointsTitle && <h1 className="pointsTitle">{pointsTitle}</h1>}
      {pointsSubtitle && <p className="pointsSubtitle">{pointsSubtitle}</p>}
      <hr className="titleLine"/>
      <div className="point_section">
        <div className={classes.cardSection}>
          {points &&
              points.map((point, index) => (
                <div className="point-item" key={index} style={{ margin: '60px 0px 3px 0px' }}>
                <Card className={classes.card}>
                  <div className={classes.icons}>
                  <img src={point.icon} alt='point'/>
                  </div>
                  <div>
                  <div className="header" style={{ marginBottom: "-5px" }}>
                    {/* <img className="point-logo" src={vector} alt="point" /> */}
                    <p className="title" style={{ color: point.color }}>{point.title}</p>
                  </div>
                  <p className="text">{point.content}</p>
                  </div>
                </Card>
                </div>
              ))}
        </div>
        <div className={classes.cardSection}>
            {point1 &&
              point1.map((point, index) => (
                <div className="point-item" key={index}  style={{ marginTop: _.isEqual(point.title, 'Use Data to Help Employees Excel') ? '60px' : 'auto' }}>
                  { !_.isEmpty(point.title) ?
                  (<>
                  <Card className={classes.card}>
                  <div className={classes.icons}>
                  <img src={point.icon} alt='point'/>
                  </div>
                  <div>
                  <div className="header" style={{ paddingTop: '10px', paddingBottom: '10px', marginBottom: "-5px"}}>
                    {/* <img className="point-logo" src={vector} alt="point" /> */}
                    <p className="title" style={{ color: point.color }}>{point.title}</p>
                  </div>
                  <p className="text" style={{ marginBottom: "1rem" }}>{point.content}</p>
                  </div>
                  </Card>
                  </>)
                  :(<>
                    <div className='benefitsImg' style={{ textAlign: "center" }}
                    // style={{ marginBottom: "-20px", marginTop: "25px"}}
                    >
                      {/* <img className="point-logo" alt="point" />
                      <p className="title">{point.title}</p> */}
                      <img className="img" src={point.url} alt='img'/>
                    </div>
                    {/* <div className="imgheader">
                    <img className="img" src={benefits} alt='img'/>
                    </div> */}
                    </>)
                }
                </div>
              ))}
        </div>
      </div>
      <br />
      <p className="subtext">{pointsSubText}</p>
    </div>
  )
}

export default Benefits
